export function AnimalFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.22 1.567a4.501 4.501 0 016.188 6.188c-.255.417-.61.696-.991.872A9.984 9.984 0 0122 12c0 5.523-4.477 10-10 10S2 17.523 2 12c0-1.21.215-2.371.61-3.445a2.223 2.223 0 01-.849-.8A4.501 4.501 0 017.95 1.567c.414.254.711.365.955.365h6.361c.244 0 .541-.111.956-.365zM11 10.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM13 14a1 1 0 10-2 0 1 1 0 01-1 1 1 1 0 100 2c.768 0 1.47-.289 2-.764.53.475 1.232.764 2 .764a1 1 0 100-2 1 1 0 01-1-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
